import { useUserStore } from '~/stores/auth';

export default defineNuxtRouteMiddleware(async (to) => {
  // Skip during server + auth internals
  if (import.meta.server) return;

  if (to.path.startsWith('/api/auth')) return;
  if (
    ['/signin', '/403', '/customer-support', '/no-study-access'].includes(
      to.path
    )
  ) {
    return;
  }

  const { status } = useAuth();

  // wait until auth resolved
  if (status.value === 'loading') return;

  if (status.value === 'unauthenticated') {
    await navigateTo('/signin');
  }

  const userStore = useUserStore();

  const user = userStore.user;

  if (user?.nonProvisionedUser) {
    return navigateTo('/no-study-access');
  }

  if (user?.nonEecUser) {
    return navigateTo('/403');
  }
});
